import { render, staticRenderFns } from "./approvedMedia.vue?vue&type=template&id=1275ada8&"
import script from "./approvedMedia.vue?vue&type=script&lang=ts&"
export * from "./approvedMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports